/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorConversationsRoute extends Route {
  queryParams = {
    page: { refreshModel: false },
    perPage: { refreshModel: false },
    reviewStatus: { refreshModel: false },
    reviewerId: { refreshModel: false },
    revieweeId: { refreshModel: false },
  };

  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.conversations',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorConversationsRoute, {
  overrideRenderTemplate: false,
});
